<div class="content-body-wrapper confirmation-popup">
  <h2 mat-dialog-title>{{ data.headerText }}</h2>
  <mat-dialog-content>
    <p class="font-size-14"  [ngStyle]="{ 'color': data?.ConfirmationType === 'error' ? 'red' : 'black' }" [innerHTML]="data?.detailText"></p>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div>
      <button
        class="action-button primary-button mr-1"
        type="button"
        mat-button
        disableRipple
        (click)="onYesClick()"
      >
        Yes
      </button>
    </div>
  </mat-dialog-actions>
</div>